import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { CVEItem } from '@/types/cve';

// Items per page
export const ITEMS_PER_PAGE = 12;

export function useCVEPagination(items: CVEItem[]) {
  const [searchParams, setSearchParams] = useSearchParams();
  const initialPage = parseInt(searchParams.get('page') || '1', 10);

  const [currentPage, setCurrentPage] = useState(initialPage);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    // Calculate total pages
    const newTotalPages = Math.ceil(items.length / ITEMS_PER_PAGE) || 1;
    setTotalPages(newTotalPages);

    // Reset to first page if current page is out of bounds
    if (currentPage > newTotalPages) {
      setCurrentPage(1);
    }
  }, [items, currentPage]);

  // Sync URL with current page
  useEffect(() => {
    setSearchParams(prev => {
      prev.set('page', currentPage.toString());
      return prev;
    });
  }, [currentPage, setSearchParams]);

  // Get current page data
  const getCurrentItems = () => {
    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    const endIndex = startIndex + ITEMS_PER_PAGE;
    return items.slice(startIndex, endIndex);
  };

  return {
    currentPage,
    totalPages,
    setCurrentPage,
    getCurrentItems
  };
}
